<section class="guide-calendar">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-header ">
          <h1 class="h1">
            Calendar
          </h1>
        </div>
      </div>
    </div>
    <div class="guide-booking-calendar">
      <div class="row">
        <div class="col-12 col-lg-5 order-last order-lg-first">
          <div class="booking-info-wrapper">
            <h6 class="booking-info-title">
              Tursday 21 April
            </h6>
            <div class="booking-info-action">
              <div class="booking-info-label text-uppercase">
                UPCOMING BOOKINGS
              </div>
              <div
                class="booking-action-buttons d-flex flex-wrap justify-content-between"
              >
                <button type="button" class="btn btn-primary">06:30 AM</button>
                <button type="button" class="btn btn-primary">10:30 AM</button>
                <button type="button" class="btn btn-primary">06:30 PM</button>
                <button type="button" class="btn btn-primary">10:30 AM</button>
                <button type="button" class="btn btn-primary">10:30 AM</button>
                <button type="button" class="btn btn-primary">06:30 PM</button>
              </div>
            </div>
            <div class="booking-info-action">
              <div class="booking-info-label text-uppercase">
                PENDING BOOKINGS
              </div>
              <div
                class="booking-action-buttons d-flex flex-wrap justify-content-between"
              >
                <button type="button" class="btn btn-outline-primary">
                  06:30 AM
                </button>
              </div>
            </div>
          </div>
          <div class="booking-info-wrapper">
            <h6 class="booking-info-title">
              Edit your availability
            </h6>
            <div class="edit-availability">
              <div class="date-input-wrapper">
                <ul
                  class="nav nav-tabs d-flex justify-content-between"
                  id="myTab"
                  role="tablist"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link active rounded-0 text-center"
                      id="single-tab"
                      data-toggle="tab"
                      href="#single"
                      role="tab"
                      aria-controls="single"
                      aria-selected="true"
                      >Single</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link rounded-0 text-center"
                      id="multiple-tab"
                      data-toggle="tab"
                      href="#multiple"
                      role="tab"
                      aria-controls="multiple"
                      aria-selected="false"
                      >Multiple</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="single"
                    role="tabpanel"
                    aria-labelledby="Single-tab"
                  >
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="singleDate" class="text-uppercase"
                          >Start date</label
                        >
                        <input
                          type="date"
                          class="form-control rounded-0"
                          id="singleDate"
                          placeholder="mm/dd/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="multiple"
                    role="tabpanel"
                    aria-labelledby="multiple-tab"
                  >
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="multipleStartDate" class="text-uppercase"
                          >Start date</label
                        >
                        <input
                          type="date"
                          class="form-control rounded-0"
                          id="multipleStartDate"
                          placeholder="mm/dd/yyyy"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="multipleEndDate" class="text-uppercase"
                          >End date</label
                        >
                        <input
                          type="date"
                          class="form-control rounded-0"
                          id="multipleEndDate"
                          placeholder="mm/dd/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-availability-actions">
                <div class="form-group">
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio1"
                      name="customRadio"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="customRadio1"
                      >Available</label
                    >
                  </div>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadio2"
                      name="customRadio"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="customRadio2"
                      >Unavailable</label
                    >
                  </div>
                </div>
                <div class="form-group d-flex justify-content-between">
                  <button class="btn btn-outline-primary rounded-0">
                    Cancel
                  </button>
                  <button class="btn btn-primary rounded-0">
                    Save Change
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="booking-info-wrapper edit-unavailable-availability">
            <h6 class="booking-info-title">
              Friday 15 April
            </h6>
            <div class="edit-availability">
              <p class="edit-paragraph">
                No bookings for the day!
              </p>
              <button
                class="btn btn-primary rounded-0 d-flex align-items-center justify-content-between"
              >
                Edit availability
                <i class="icon-edit"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 offset-lg-1 order-first order-lg-last">
          <div class="booking-calendar">
            <app-calendar></app-calendar>
          </div>
          <div class="calendar-sign">
            <span class="bookings-sign">BOOKINGS</span>
            <span class="unavailable-sign">UNAVAILABLE</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
